<template>
    <el-dialog :modal-append-to-body="false" :close-on-click-modal="false" custom-class="delCarMusic" title="开票"
        :visible.sync="payDialogVisible" width="690px" :before-close="handlePayClose">
        <el-divider></el-divider>
        <div class="pay">
            <div class="purpose">
                <p style="width: 70px;text-align-last:justify;text-align:justify;text-justify:distribute-all-lines;">
                    歌曲用途：</p>
                <el-input placeholder="请输入歌曲用途" :readonly="purposeFlag" v-model="purpose"></el-input>
            </div>
            <uploadVue v-if="(!applyInfo.deposit_info && !applyInfo.qualificat && applyInfo.type == 2)" @taxpayer="taxpayer" @deposit="deposit">
            </uploadVue>
            <div class="payTitle">
                <div>
                    <p
                        style="width: 100px;margin-right: 15px;text-align-last:justify;text-align:justify;text-justify:distribute-all-lines;">
                        发票类型：</p>
                    <el-radio v-model="radio" label="2">增值税专用发票 <span class="rate">(税率6%)</span></el-radio>
                    <el-radio v-model="radio" label="1">普通发票 <span class="rate">(税率6%)</span></el-radio>
                </div>
                <div>
                    <p
                        style="width: 100px;margin-right: 15px;text-align-last:justify;text-align:justify;text-justify:distribute-all-lines;">
                         发票金额：</p>
                    <h2>￥ {{ amount }}</h2>
                </div>
                <div>
                    <p
                        style="width: 100px;margin-right: 15px;text-align-last:justify;text-align:justify;text-justify:distribute-all-lines;">
                         发票内容：</p>
                    <el-select v-model="value" size="mini" placeholder="请选择发票内容" style="width: 300px;">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="color:red;margin-left: 10px;font-weight: bold;">*</span>
                </div>
            </div>
            <div class="info">
                <h3>收票信息</h3>
                <div class="payee">
                    <p>收票方信息：</p>
                    <span v-if="applyInfo.type == 2">公司</span>
                    <span v-else-if="applyInfo.type == 1">个人</span>
                </div>
                <div class="info_box" v-show="applyInfo.type == 2">
                    <div class="info_item" v-for="i in infoList" :key="i.name">
                        <div class="info_item_name">
                            <p>{{ i.name }}</p>
                            <span v-if="i.tips">{{ i.tips }}</span>
                        </div>
                        <el-input v-model="i.msg" readonly :placeholder="i.placeholder"></el-input>
                    </div>
                </div>
                <div class="info_box" v-show="applyInfo.type == 1">
                    <div class="info_item" v-for="i in personList" :key="i.name">
                        <div class="info_item_name">
                            <p>{{ i.name }}</p>
                            <span v-if="i.tips">{{ i.tips }}</span>
                        </div>
                        <el-input v-model="i.msg" readonly :placeholder="i.placeholder"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <p slot="footer" class="dialog-footer payFooter">
            <el-button type="primary" @click="apply">申请开票</el-button>
        </p>
    </el-dialog>
</template>

<script>
import formateNum from '@/assets/js/money'
import uploadVue from '../center/upload.vue'
export default {
    data() {
        return {
            payDialogVisible: false,
            radio: '2',
            input: '',
            infoList: [
                {
                    name: '公司名称',
                    msg: '',
                    tips: '必须与付款方保持一致，否则无法开具',
                    placeholder: '请输入公司名称'
                },
                {
                    name: '地址',
                    msg: '',
                    placeholder: '请输入地址'
                },
                {
                    name: '电话',
                    msg: '',
                    placeholder: '请输入电话'

                },
                {
                    name: '开户行名称',
                    msg: '213123',
                    placeholder: '请输入开户行名称'
                },
                {
                    name: '银行账号',
                    msg: '',
                    placeholder: '请输入银行账号'
                },
            ],
            personList: [
                {
                    name: '姓名',
                    msg: '李魏',
                    tips: '',
                    placeholder: '请输入姓名'

                },
                {
                    name: '身份证号',
                    msg: '',
                    placeholder: '请输入身份证号'

                },
            ],
            purpose: '',
            purposeFlag: false,
            amount: '',
            value: '',
            options: [{
                value: '现代服务*版权使用费',
                label: '现代服务*版权使用费'
            }, {
                value: '现代服务*版权服务费',
                label: '现代服务*版权服务费'
            }, {
                value: '现代服务*版权授权使用费',
                label: '现代服务*版权授权使用费'
            }],
            qualificat: '',//一半纳税人资质
            deposit_info: '',//存款
        }
    },
    props: {
        applyInfo: {
            type: Object,
            default: () => { }
        },
        orderId: {
            type: [Number, String],
            default: ''
        }
    },
    components: {
        uploadVue
    },
    watch: {
        amount(val, old) {
            console.log(val, old, '')
        },
        applyInfo(val) {
            if (val.id) {
                if (val.type == 1) {
                    this.personList[0].msg = this.applyInfo.real_name
                    this.personList[1].msg = this.applyInfo.id_number
                } else if (val.type == 2) {
                    this.infoList[0].msg = this.applyInfo.company_name
                    this.infoList[1].msg = this.applyInfo.address
                    this.infoList[2].msg = this.applyInfo.contact_mobile
                    this.infoList[3].msg = this.applyInfo.bank_name
                    this.infoList[4].msg = this.applyInfo.account
                }
            }
        },
        orderId: {
            async handler(val, old) {
                if (val) {
                    let data = {
                        id: val
                    }
                    let res = await this.$home.orderInfo(data)
                    if (res.code == 200) {
                        this.amount = formateNum(res.data.amount * 1)
                        if (res.data.purpose != '') {
                            this.purpose = res.data.purpose
                            this.purposeFlag = true
                        }
                    }

                }
            }


        },
        payDialogVisible(val) {
            if (!val) {
                this.purposeFlag = false
                this.purpose = ''
                this.$parent.orderId = ''
                this.amount = ''
                this.value = ''
            }
            this.purpose = ''
        }
    },
    mounted() {
        console.log(this.orderId, ';oooo开发票')
    },
    methods: {
        taxpayer(val) {
            this.qualificat = val
        },
        deposit(val) {
            this.deposit_info = val
        },
        handlePayClose() {
            this.payDialogVisible = false
        },
        apply() {
            let val = {
                purpose: this.purpose,
                type: this.radio * 1,
                order_id: this.orderId * 1,
                content: this.value,
            }
            if (this.purpose == '') return this.$msg('error', '提示', '歌曲用途不能为空')
            if (this.value == '') return this.$msg('error', '提示', '发票内容不能为空')
            if (this.applyInfo.type == 2 && !this.applyInfo.qualificat && !this.applyInfo.deposit_info) {
                val.qualificat = this.qualificat
                val.deposit_info = this.deposit_info
                if (this.qualificat == '') return this.$msg('error', '提示', '一般纳税人资质不能为空')
                if (this.deposit_info == '') return this.$msg('error', '提示', '开户许可证或基本存缴信息证明不能为空')
            }
            this.$home.invoicing(val).then(res => {
                if (res.code == 200) {
                    this.$emit('update', 'apply')
                    this.$msg('success', '提示', res.msg)
                    this.payDialogVisible = false
                } else {
                    this.$msg('error', '提示', res.msg)
                }
            }).catch(err => {
                console.log(err);
            })
        },

    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-select>.el-input{
    font-size: 14px;
}
.payFooter {
    text-align: right;
}

::v-deep .el-dialog {
    max-height: 880px;
    overflow-y: auto;
}

::v-deep .el-dialog__header {
    padding: 20px 30px;
    padding-bottom: 10px;
}

::v-deep .el-dialog__footer {
    text-align: left;
    padding: 20px 30px;
}

::v-deep .el-dialog__body {
    margin: 0 30px;
    padding: 0;
    // padding-bottom: 10px;

    .el-divider--horizontal {
        margin: 14px 0 24px 0;
    }
}

::v-deep .el-dialog__title {
    font-weight: 600;
}


.purpose {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dcdfe6;

    p {
        flex-shrink: 0;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }

    ::v-deep .el-input__inner {
        border: none !important;
    }
}

.payTitle {
    padding: 10px 0;
    border-bottom: 1px dashed #AAAAAA;
    // padding-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .rate {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    >div {
        display: flex;
        align-items: center;
        line-height: 30px;

        p {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
        }

        ::v-deep .el-radio__label {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }

        h2 {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
        }
    }
}

.info {
    padding: 24px 0;

    h3 {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
    }

    .payee {
        display: flex;
        margin-top: 20px;
        align-items: center;

        p {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
        }
    }

    .info_box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 24px 24px;
        margin-top: 20px;

        ::v-deep .el-input__inner {
            border: none;
            border-radius: 0;
            padding: 0;
            border-bottom: 1px solid #dcdfe6;
        }

        .info_item {
            .info_item_name {
                margin-bottom: 10px;

                display: flex;
                align-items: center;

                p {
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }

                span {
                    font-size: 10px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #AAAAAA;
                    margin-left: 7px;
                }

            }
        }
    }
}
</style>